//@flow
import React from 'react';
import {
  // Alert,
  // Button
} from 'lib/elements'
import Badge from '../../badge/index';
import css from './notifier.css';

import {
  FontAwesomeIcon as FontAwesome
} from '@fortawesome/react-fontawesome';
import {
  faTimes
} from '@fortawesome/free-solid-svg-icons'

import
NotifierActions
from './Actions';
import {
  Notification
} from './Notification'

type Props = {
  mode: string, // "alert" | "inline"
  notifications: ? Array < * >
}
class Notifier extends React.Component < Props > {

  handleAlertDismiss(id: string) {
    NotifierActions.dropNotification(id)
  }

  renderNotification(n: Notification) {
    if (this.props.mode === "alert") {
      // return <Alert className={css.alert} key={n.id} bsStyle={n.getLevel()} onDismiss={(e)=>this.handleAlertDismiss(n.id)}>
      //   <h4>{n.getSubject()}</h4>
      //   <p>{n.getMessage()}</p>
      //   <p>
      //     <Button bsStyle={n.getLevel()} bsSize='small' onClick={(e)=>this.handleAlertDismiss(n.id)}>Dismiss</Button>
      //   </p>
      // </Alert>;
    } else {
      const icon = n.level === 'success' ? "check" : "exclamation-triangle";

      const subject = n.getSubject() ? <div className={css.inlineSubject}>
        <FontAwesome icon={icon}/>&nbsp;{n.getSubject()}</div> : null;

      const message = n.getMessage() ? <div className={css.inlineMessage}>
        <FontAwesome icon="chevron-right"/>&nbsp;&nbsp;<em>{n.getMessage().slice(0,40)}...</em>
      </div> : null;


      /////////////////////////////LEAVE THIS HERE
      console.error(n.getLevel(), n.getSubject(), n.getMessage());
      ///////////////////////////


      return <div className={css.inline} key={n.id}>
        {subject}
          {message}
          <div className={css.inlineButton} onClick={(e)=>this.handleAlertDismiss(n.id)}><FontAwesome icon={faTimes}/>&nbsp;Dismiss</div>
        </div>
    }
  }

  render() {
    if (!this.props.notifications) return null;

    const alerts = this.props.notifications.map((v, k) => {
      return this.renderNotification(v)
    });

    const count = alerts.length > 1 ?
      <Badge count={alerts.length}/> :
      null;
    // flow doesn't realise that ALERTS is an ordered map not an array. ImmutableJS possibly ignored in flowconfig?

    return <div className={css.notifier}>{alerts[0]} {count}</div>
  }
}

export default Notifier;